import moment from 'moment';

const refreshAuthStatus = () => {
  let refToken = localStorage.getItem('refreshToken'),
    refExp = localStorage.getItem('refreshExpiresAt'),
    isAfter = null;

  if (!refExp) return false;

  isAfter = moment.unix(refExp).isAfter(moment());

  if (!isAfter) removeTokens();

  return refToken && isAfter;
};

const getDefaultState = () => ({
  fetch: false,
  authenticated: refreshAuthStatus(),
  id: null,
  email: '',
  password: '',
  remember: false,
  token: localStorage.getItem('accessToken') || '',
  status: '',
  error: '',
  info: JSON.parse(localStorage.getItem('info'))
});

const removeTokens = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('accessExpiresAt');
  localStorage.removeItem('refreshExpiresAt');
};

const clearCache = () => {
  localStorage.clear();
};

const state = getDefaultState();

const mutations = {
  updateLogin(state, data) {
    const accessToken = data.accessToken;

    state.error = '';
    state.token = accessToken;
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', data.refreshToken);
    localStorage.setItem('accessExpiresAt', data.accessExpiresAt);
    localStorage.setItem('refreshExpiresAt', data.refreshExpiresAt);
    state.authenticated = refreshAuthStatus();
  },

  updateAuthFailure(state, error) {
    state.error = error;
    removeTokens();
    state.token = '';
  },

  updateLogout(state) {
    removeTokens();
    state.token = '';
    state.authenticated = false;
    // clearCache();
  },
  trocarIdioma(state, idioma) {
    if (state.info && state.info.idioma) {
      state.info.idioma = idioma;
    } else {
      state.info = { ...state.info, idioma };
    }
    localStorage.setItem('info', JSON.stringify(state.info));
  }
};

const actions = {
  registerAuthFailure({ commit }, error) {
    commit('updateAuthFailure', error);
  },

  registerLogin({ commit }, response) {
    commit('updateLogin', response);
  },

  logout({ commit }) {
    commit('updateLogout');
  },
  registerTrocarIdioma({ commit }, idioma) {
    commit('trocarIdioma', idioma);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
